export const DRAG_ACTIVE_OPACITY = 0.6;

export const activeZoneStyle = (isDragActive: boolean) => ({
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  overflow: "hidden",
  position: "relative",
  borderRadius: "8px",
  opacity: isDragActive ? DRAG_ACTIVE_OPACITY : 1,
  transition:
    "border-color 120ms ease, background 120ms ease, box-shadow 120ms ease, opacity 120ms ease",
});

export const validationErrorWrapperStyle = {
  position: "absolute",
  top: "12px",
  left: "12px",
  right: "12px",
  zIndex: 10,
};
